module.exports = __webpack_public_path__ + "static/scannerBanner-0a4e8005eebe80651fa0239818adcc3b.png";